import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const Hypertension = {
  label: "高血壓",
  key: "Hypertension",
  path: "Diabetes/Hypertension",
  api: "TCS_V_Exam_3H",
  render: (options) => <Diagram.Diabetes.Hypertension {...options} />,
  filter: {
    key: "種類",
    value: "高血壓",
  },
  isGroup: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  filterColumns: [{ key: "創建日期", type: "date" }],
  levelColumns,
  columns: [],
  exportColumns: [
    {
      key: "是否異常",
      label: "是否異常",
    },
  ],
};
